// Dashboard.js

import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import Header from "../Includes/Header";
import Sidebar from "../Includes/Sidebar";
import GraphChart from "./GraphChart.jsx";
import BarChart from "./BarChart.jsx";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import the back arrow icon


import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  Container,
  TablePagination,
  CssBaseline,
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PieChart from "./PieChart.jsx";
// import { Grid } from '@mui/material';
import React, { useEffect, useState } from "react";
const drawerWidth = 240;
import {
  getActivePT,
  getUpcomingExpire,
  getPendingDue,
} from "../Apihelper/Dashboard.js";
import { useTheme as useAppTheme } from "../../contexts/ThemeContext";
const steps = ["Step 1", "Step 2"]; // Define your steps here
const useCardStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
  height: "95px", // Consistent height for all cards
  borderRadius: "12px",
  textAlign: "center", // Center align all text within the card
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s, box-shadow 0.3s",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 6px 25px rgba(0, 0, 0, 0.15)",
  },
};
const useValueStyles = {
  fontSize: "16px", // Smaller font size for the values
  color: "#555",
};
const useTypographyStyles = {
  fontSize: "12px", // Smaller font size for the titles
  fontWeight: "bold",
  color: "#333",
};
const useTableStyles = {
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(31, 122, 84, 0.1)",
  overflow: "hidden",
  marginTop: "10px",
};

const useTableCellStyles = {
  fontWeight: "bold",
  color: "#fff",
  textAlign: "center",
};

const useTableBodyCellStyles = {
  padding: "12px",
  textAlign: "center",
  color: "#333",
  fontSize: "14px",
};

const useTableRowStyles = {
  "&:hover": {
    backgroundColor: "#f5f5f5",
    transition: "background-color 0.3s",
  },
};
const Dashboard = () => {
  const { colors: appColors } = useAppTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState(null); // State for storing error messages
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();
  useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate("/");
    }
  }, []);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0); // To hold the total count for pagination

  const [searchText, setSearchText] = useState(""); // Search input if any
  const [loading, setLoading] = useState(false); // Loading state
  const [datapending, setDatapending] = useState([]);
  const [pagepending, setPagepending] = useState(0);
  const [rowsPerPagepending, setRowsPerPagepending] = useState(5);
  const [totalCountpending, setTotalCountpending] = useState(0); // To hold the total count for pagination

  const [searchTextpending, setSearchTextpending] = useState(""); // Search input if any
  const [dataActivePT, setDataActivePT] = useState([]); // Changed from datapending to dataActivePT
  const [pageActivePT, setPageActivePT] = useState(0); // Changed from pagepending to pageActivePT
  const [rowsPerPageActivePT, setRowsPerPageActivePT] = useState(5); // Changed from rowsPerPagepending to rowsPerPageActivePT
  const [totalCountActivePT, setTotalCountActivePT] = useState(0); // Changed from totalCountpending to totalCountActivePT

  const [searchTextActivePT, setSearchTextActivePT] = useState(""); // Changed from searchTextpending to searchTextActivePT
  const [loadingUpcoming, setLoadingUpcoming] = useState(false);
  const [loadingPending, setLoadingPending] = useState(false);
  const [loadingActivePT, setLoadingActivePT] = useState(false);
  
  // Fetch data from the API based on page and rowsPerPage
  const fetchData = async () => {
    setLoadingUpcoming(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userdata"));
      const { token, id: userId } = userData;
      const result = await getUpcomingExpire(
        token,
        rowsPerPage,
        searchText,
        page + 1
      ); // Passing token and pagination params
      setData(result.data); // Assuming `data` is where the list resides
      setTotalCount(result.total); // Assuming total count is returned for pagination
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingUpcoming(false);
    }
  };
  const fetchDatapending = async () => {
    setLoadingPending(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userdata"));
      const { token, id: userId } = userData;
      const result = await getPendingDue(
        token,
        rowsPerPagepending,
        searchText,
        pagepending + 1
      ); // Passing token and pagination params
      setDatapending(result.data); // Assuming `data` is where the list resides
      setTotalCountpending(result.total); // Assuming total count is returned for pagination
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPending(false);
    }
  };
  const fetchDatActivePT = async () => {
    setLoadingActivePT(true);
    try {
        const userData = JSON.parse(localStorage.getItem("userdata"));
        const { token, id: userId } = userData;

        // Use the updated state variables
        const result = await getActivePT(
            token,
            rowsPerPageActivePT, // Use rowsPerPageActivePT
            searchTextActivePT, // Use searchTextActivePT
            pageActivePT + 1 // Use pageActivePT
        ); 

        setDataActivePT(result.data); // Set the active PT data
        setTotalCountActivePT(result.total); // Set the total count for pagination
    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
      setLoadingActivePT(false);
    }
};


  // Fetch data when component mounts or when pagination/search changes
  useEffect(() => {
    fetchData();
   
  }, [page, rowsPerPage, ]);
  useEffect(() => {
  
   
    fetchDatActivePT();
  }, [pageActivePT,rowsPerPageActivePT]);
  useEffect(() => {
  
    fetchDatapending();
    
  }, [,pagepending,rowsPerPagepending]);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onPageChangedue = (event, newPage) => {
    setPagepending(newPage);
  };

  const onRowsPerPageChangedue = (event) => {
    setRowsPerPagepending(parseInt(event.target.value, 10));
    setPagepending(0); // Reset to the first page when changing rows per page
  };
  const onPageChangeActivePT = (event, newPage) => {
    setPageActivePT(newPage); // Use the new state variable for ActivePT
};

const onRowsPerPageChangeActivePT = (event) => {
    setRowsPerPageActivePT(parseInt(event.target.value, 10)); // Use the new state variable for ActivePT
    setPageActivePT(0); // Reset to the first page when changing rows per page
};


  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#EFEDF1", flexDirection: { xs: "column", sm: "row" } }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflowX: 'hidden',
          overflowY: 'auto',
          padding: { xs: '12px', sm: '16px', md: '20px' },
          marginTop: { xs: '56px', sm: '64px' },
          backgroundColor: '#f9f9f9',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '100%', marginTop: { xs: 0, sm: '8px' } }}>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={{ xs: 1, sm: 2, md: 4 }}
            sx={{ width: '100%', margin: 0 }}
          >
            <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                fullWidth={isMobile}
                sx={{
                  boxShadow: 4,
                  borderRadius: '10px',
                  fontWeight: "bold",
                  overflow: 'hidden',
                  marginBottom: '12px',
                  backgroundColor: appColors.evergreen,
                  '&:hover': { backgroundColor: appColors.leaf },
                }}
                startIcon={<ArrowBackIcon />}
              >
                Go Back
              </Button>
              <Card sx={{ 
              boxShadow: '0 4px 20px rgba(31, 122, 84, 0.1)', 
              borderRadius: '10px', 
              overflow: 'hidden',
              backgroundColor: '#ffffff',
            }}>
            <Typography sx={{
              fontSize: { xs: '14px', sm: '16px' },
              fontWeight: 'bold',
              margin: '10px 0px',
              color: appColors.evergreen,
              textAlign: 'center',
            }}>
            Active PT
          </Typography>
              <TableContainer sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table sx={{ minWidth: { xs: 640, sm: 700 } }} size={isMobile ? 'small' : 'medium'}>
                  <TableHead>
                    <TableRow sx={{
                      backgroundColor: appColors.evergreen,
                      '& th': {
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: { xs: '11px', sm: '14px', md: '16px' },
                        padding: { xs: '8px', sm: '16px' },
                        whiteSpace: 'nowrap',
                      }
                    }}>
                      <TableCell>Sl. No.</TableCell>
                      <TableCell>Image</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Mid</TableCell>
                      <TableCell>Phone No.</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Expire Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingActivePT ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      dataActivePT
                        .slice(
                          pageActivePT * rowsPerPageActivePT,
                          pageActivePT * rowsPerPageActivePT + rowsPerPageActivePT
                        )
                        .map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(31, 122, 84, 0.04)',
                                transition: 'background-color 0.2s'
                              }
                            }}
                          >
                            <TableCell sx={{
                              padding: { xs: '6px', sm: '16px' },
                              fontSize: { xs: '11px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{pageActivePT * rowsPerPageActivePT + index + 1}</TableCell>
                            <TableCell sx={{ padding: { xs: '6px', sm: '16px' } }}>
                              <img
                                src={row.image}
                                alt={row.name}
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  border: `1px solid ${appColors.evergreen}`,
                                  objectFit: 'cover',
                                  minWidth: 40,
                                  minHeight: 40,
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.name}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.membership_number}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.phone}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.email}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.expire_date}</TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCountActivePT}
                  rowsPerPage={rowsPerPageActivePT}
                  page={pageActivePT}
                  onPageChange={onPageChangeActivePT}
                  onRowsPerPageChange={onRowsPerPageChangeActivePT}
                  sx={{
                    flexWrap: 'wrap',
                    '.MuiTablePagination-select': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-selectIcon': { color: appColors.evergreen },
                    '.MuiTablePagination-displayedRows': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-actions': { marginLeft: 0 },
                  }}
                  labelRowsPerPage={isMobile ? '' : 'Rows per page:'}
                />
              </TableContainer>
            </Card>
          </Grid>

          {/* Pending Due Table */}
          <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
            <Card sx={{ 
              marginTop: '10px', 
              boxShadow: '0 4px 20px rgba(31, 122, 84, 0.1)', 
              borderRadius: '10px',
              overflow: 'hidden',
              backgroundColor: '#ffffff',
            }}>
              <Typography sx={{
                fontSize: { xs: '14px', sm: '16px' },
                  fontWeight: 'bold',
                margin: '10px 0px',
                color: appColors.evergreen,
                  textAlign: 'center',
              }}>
                Pending Due
              </Typography>
              <TableContainer sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table sx={{ minWidth: { xs: 560, sm: 600 } }} size={isMobile ? 'small' : 'medium'}>
                  <TableHead>
                    <TableRow sx={{
                      backgroundColor: appColors.evergreen,
                      '& th': {
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: { xs: '11px', sm: '14px', md: '16px' },
                        padding: { xs: '8px', sm: '16px' },
                        whiteSpace: 'nowrap',
                      }
                    }}>
                      <TableCell>Sl. No.</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Mid</TableCell>
                      <TableCell>Phone No.</TableCell>
                      <TableCell>Due Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingPending ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      datapending
                        .slice(
                          pagepending * rowsPerPagepending,
                          pagepending * rowsPerPagepending + rowsPerPagepending
                        )
                        .map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(31, 122, 84, 0.04)',
                                transition: 'background-color 0.2s'
                              }
                            }}
                          >
                            <TableCell sx={{
                              padding: { xs: '6px', sm: '16px' },
                              fontSize: { xs: '11px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{pagepending * rowsPerPagepending + index + 1}</TableCell>
                            <TableCell sx={{
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.name}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.membership_number}</TableCell>
                            <TableCell sx={{ 
                              padding: { xs: '8px', sm: '16px' },
                              fontSize: { xs: '12px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.phone}</TableCell>
                            <TableCell sx={{
                              padding: { xs: '6px', sm: '16px' },
                              fontSize: { xs: '11px', sm: '14px' },
                              whiteSpace: 'nowrap',
                              color: '#1e293b'
                            }}>{row.total_due}</TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCountpending}
                  rowsPerPage={rowsPerPagepending}
                  page={pagepending}
                  onPageChange={onPageChangedue}
                  onRowsPerPageChange={onRowsPerPageChangedue}
                  sx={{
                    flexWrap: 'wrap',
                    '.MuiTablePagination-select': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-selectIcon': { color: appColors.evergreen },
                    '.MuiTablePagination-displayedRows': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-actions': { marginLeft: 0 },
                  }}
                  labelRowsPerPage={isMobile ? '' : 'Rows per page:'}
                />
              </TableContainer>
            </Card>
          </Grid>

          {/* Upcoming Membership Expiry Table */}
          <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
            <Card sx={{ 
              marginTop: '10px', 
              boxShadow: '0 4px 20px rgba(31, 122, 84, 0.1)', 
              borderRadius: '10px',
              overflow: 'hidden',
              backgroundColor: '#ffffff',
            }}>
              <Typography sx={{
                fontSize: { xs: '14px', sm: '16px' },
                  fontWeight: 'bold',
                margin: '10px 0px',
                color: appColors.evergreen,
                  textAlign: 'center',
              }}>
                Upcoming Membership Expiry
              </Typography>
              <TableContainer sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <Table sx={{ minWidth: { xs: 560, sm: 600 } }} size={isMobile ? 'small' : 'medium'}>
                  <TableHead>
                    <TableRow sx={{
                      backgroundColor: appColors.evergreen,
                      '& th': {
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: { xs: '11px', sm: '14px', md: '16px' },
                        padding: { xs: '8px', sm: '16px' },
                        whiteSpace: 'nowrap',
                      }
                    }}>
                      <TableCell>Sl. No.</TableCell>
                      <TableCell>Image</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Mid</TableCell>
                      <TableCell>Phone No.</TableCell>
                      <TableCell>Expire Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingUpcoming ? (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : data.length > 0 ? (
                      data.map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(31, 122, 84, 0.04)',
                              transition: 'background-color 0.2s'
                            }
                          }}
                        >
                          <TableCell sx={{
                            padding: { xs: '6px', sm: '16px' },
                            fontSize: { xs: '11px', sm: '14px' },
                            whiteSpace: 'nowrap',
                            color: '#1e293b'
                          }}>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell sx={{ padding: { xs: '6px', sm: '16px' } }}>
                            <img
                              src={row.image}
                              alt={row.name}
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                border: `1px solid ${appColors.evergreen}`,
                                objectFit: 'cover',
                                minWidth: 40,
                                minHeight: 40,
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ 
                            padding: { xs: '8px', sm: '16px' },
                            fontSize: { xs: '12px', sm: '14px' },
                            whiteSpace: 'nowrap',
                            color: '#1e293b'
                          }}>{row.name}</TableCell>
                          <TableCell sx={{ 
                            padding: { xs: '8px', sm: '16px' },
                            fontSize: { xs: '12px', sm: '14px' },
                            whiteSpace: 'nowrap',
                            color: '#1e293b'
                          }}>{row.membership_number}</TableCell>
                          <TableCell sx={{ 
                            padding: { xs: '8px', sm: '16px' },
                            fontSize: { xs: '12px', sm: '14px' },
                            whiteSpace: 'nowrap',
                            color: '#1e293b'
                          }}>{row.phone}</TableCell>
                          <TableCell sx={{
                            padding: { xs: '6px', sm: '16px' },
                            fontSize: { xs: '11px', sm: '14px' },
                            whiteSpace: 'nowrap',
                            color: '#1e293b'
                          }}>{row.expire_date}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          <Typography>No upcoming expiries.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    flexWrap: 'wrap',
                    '.MuiTablePagination-select': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-selectIcon': { color: appColors.evergreen },
                    '.MuiTablePagination-displayedRows': { color: appColors.evergreen, fontSize: { xs: '0.8125rem', sm: '0.875rem' } },
                    '.MuiTablePagination-actions': { marginLeft: 0 },
                  }}
                  labelRowsPerPage={isMobile ? '' : 'Rows per page:'}
                />
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;